<template>
  <div>
    <ModalCover
      @closeModal="$emit('closeTriggered')"
      :show_close="false"
      modal_style="modal-sm-md-init rounded-15"
    >
      <!-- MODAL BODY -->
      <div slot="modal-cover-body">
        <div class="select-topic-modal">
          <!-- TOP CONTAINER -->
          <div class="top-container brand_navy_bg">
            <div class="title-text color_white font-weight-bold">
              Assign Learning Area
            </div>

            <!-- SEARCH FORM -->
            <div class="input-box position-relative">
              <input
                type="search"
                class="form-control"
                v-model="query"
                placeholder="Search Topic"
              />
              <!-- ADD-ONS -->
              <div
                class="icon icon-search brand_accent font-24 position-absolute"
              ></div>
              <div
                @click="clearSearch"
                class="icon brand_tonic border_grey_dark font-21 position-absolute pointer"
              ></div>
            </div>
          </div>

          <!-- BOTTOM CONTAINER -->
          <div class="bottom-container">
            <!-- SEARCH COUNTER -->
            <div class="search-counter color_grey_dark">
              <span class="count">{{ search_results.length }}</span>
              &nbsp;Topic{{ search_results.length > 1 ? "s" : "" }} Found
            </div>

            <template v-if="isFetching" name="fade" mode="out-in">
              <div
                class="loader d-flex justify-content-center align-items-center my-5"
              >
                <div class="icon-dotted-roller font-20 mr-2 animate row"></div>
                <span>Fetching ..</span>
              </div>
            </template>

            <!-- SEARCH RESULT COMPONENT -->
            <SearchResultCard
              :topic_index="index"
              :topic_title="search.topic"
              :topic_term="search.term"
              :topic_week="search.week"
              :selected="search.selected"
              v-for="(search, index) in search_results"
              :key="index"
              @topicSelected="makeSelection($event)"
            ></SearchResultCard>
            <!-- SEARCH RESULT COMPONENT -->

            <!-- BUTTON ROW -->
            <div
              class="button-row d-flex justify-content-center align-items-center nowrap"
            >
              <button
                class="btn btn-md transparent-bg z-depth-0 mr-3 brand_navy"
                @click="$emit('closeTriggered')"
              >
                Cancel
              </button>
              <button
                v-if="search_results.length > 0"
                class="btn btn-md btn-accent ml-3"
                @click="confirmSelection"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </ModalCover>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { debounce } from "lodash";
import { capitalizeFirstLetter } from "@/scripts/utilities";
import ModalCover from "@/components/globalComps/ModalCover";
import SearchResultCard from "@/components/classComps/assessment/SearchResultCard";

export default {
  name: "SelectTopicModal",

  components: {
    ModalCover,
    SearchResultCard,
  },

  data() {
    return {
      account_type: null,
      return_link: "",
      query: "",
      selection_type: "single", //multiple
      search_results: [],
      selected_list: [],
      isFetching: false,
    };
  },
  
  computed: {
    ...mapGetters(["getCurrentlySelectHomework"]),
  },

  watch: {
    query: {
      handler: debounce(function(val) {
        if (val.length >= 2) this.fetchTopics();
        else if (val.length === 0) this.search_results = [];
      }, 1000),
    },
  },

  mounted() {
    this.getAccountType();
    this.fetchTopics();
  },

  methods: {
    ...mapActions(["searchForTopic"]),

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];

      //   if (this.account_type === "school") {
      //     this.return_link = "ClassHomework";
      //   } else if (this.account_type === "teacher") {
      //     this.return_link = "TeacherHomework";
      //   }
    },

    makeSelection(index) {
      // SINGLE SELECTIONS
      if (this.selection_type === "single") {
        this.selected_list = [];
        this.search_results.map((search) => (search.selected = false));
        this.search_results[index].selected = true;
        this.selected_list.push(this.search_results[index]);
      }
      // MULTIPLE SELECTIONS
      else if (this.selection_type === "multiple") {
        this.search_results[index].selected === true
          ? (this.search_results[index].selected = false)
          : (this.search_results[index].selected = true);

        let new_topics = this.search_results;
        this.selected_list = [];
        this.search_results = [];

        new_topics.map((search) => {
          this.search_results.push(search);
        });
        this.search_results.map((search) => {
          search.selected === true ? this.selected_list.push(search) : "";
        });
      }
    },

    clearSearch() {
      this.query = "";
      this.search_results = [];
    },

    fetchTopics() {
      this.search_results = [];
      this.isFetching = true;

      this.searchForTopic({
        global_class_id: this.getCurrentlySelectHomework.global_class_id,
        subject_id: this.getCurrentlySelectHomework.subject_id,
        topic: this.query,
      })
        .then((res) => {
          console.log(res);
          this.isFetching = false;
          if (res.code === 200) {
            this.event_count = res.data.length;
            this.search_results = res.data.map((item) => {
              if (item.status)
                return {
                  topic_id: item.id,
                  topic: item.topic,
                  term: `${capitalizeFirstLetter(item.term)} Term`,
                  week: `Week ${item.week_number}`,
                  selected: false,
                };
            });
          } else {
            this.event_count = 0;
            this.search_results = [];
          }
        })
        .catch((err) => {
          this.isFetching = false;
          console.log(err);
        });
    },

    confirmSelection() {
      this.$emit("listSelected", {
        topics: this.selected_list,
      });
      this.$emit("closeTriggered");
    },
  },
};
</script>

<style lang="scss">
.select-topic-modal {
  .top-container {
    padding: 17px 22px;

    .title-text {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 15px;
    }

    .input-box {
      .form-control {
        padding-left: 50px;
      }

      .icon {
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
      }

      .icon-search {
        left: 12px;
      }

      .icon-decline {
        right: 12px;
        transition: all 0.4s ease-in-out;

        &:hover {
          color: $brand_tonic !important;
        }
      }
    }
  }

  .bottom-container {
    padding: 17px 22px;

    .search-counter {
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 15px;
    }

    .button-row {
      border-top: 1px solid $border_grey;
      margin-top: 15px;
      padding-top: 20px;
    }
  }
}
</style>
